module.exports = __webpack_public_path__ + "media/images/flags/32/Ireland-944f3ab48994033201e409fdd594ac41.png";